const SliderData = [
  {
    id: 1,
    image:
      "https://images.pexels.com/photos/2233729/pexels-photo-2233729.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: " About Paneer tikaka ",
    text: "Paneer is a rich source of protein and nutrition. It is full of mineral elements such as potassium, magnesium, and calcium. This may play a central role in regulating and lowering high blood pressure.",
  },
  {
    id: 2,
    image:
      "https://images.pexels.com/photos/2255925/pexels-photo-2255925.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "About Green  Vegetables",
    text: "Green vegetables are a rich source of calcium that helps children get enough calcium, which is crucial to building bone mass.",
  },
  {
    id: 3,
    image:
      "https://images.pexels.com/photos/24182556/pexels-photo-24182556/free-photo-of-pizza-served-in-a-restaurant.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    title: "About fast food & Junk food",
    text: "High in calories and unhealthy fats, junk food contributes to obesity and weight-related issues. Regular consumption of junk food can elevate the risk of heart disease, diabetes, and hypertension.",
  },
  {
    id: 4,
    image:
      "https://5.imimg.com/data5/SELLER/Default/2023/3/296872949/ZZ/GG/BW/77999044/cold-drink-recipe-formulation.jpeg",
    title: "About Cold Drinks",
    text: "Soft drinks has far more serious health issues are turned into many type of diseases such as Diabetes, body weight, heart disease, liver damage, bone health, among children and aged persons."
  },
];

export { SliderData };
